<template>
  <v-dialog
    :model-value="modelValue"
    @update:model-value="toggleDialog"
    max-width="340px"
    :scroll-strategy="'none'"
    :close-on-content-click="false"
  >
    <v-card>
      <v-card-item class="pa-0">
        <span class="edit-title">Edit Domain Event</span>
        <v-btn
          icon="mdi-close"
          variant="plain"
          class="ml-auto"
          @click="toggleDialog(false)"
        />
      </v-card-item>
      <v-card-text v-if="schema" class="d-flex justify-center pa-4 pb-8">
        <domain-event-card
          :schema="schema"
          :hideDelete="true"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script setup>
import DomainEventCard from '@/components/DomainEventCard.vue'

defineProps({
  modelValue: Boolean,
  schema: Object
})
const emit = defineEmits(['update:modelValue'])

const toggleDialog = (value) => {
  emit('update:modelValue', value)
}
</script>

<style scoped>
.v-card {
  border: 1px solid var(--dark-2);
}

:deep(.v-card-item__content) {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  padding: 10px;

  .edit-title {
    font-size: 20px;
    color: var(--text-light) !important;
  }
}
</style>
